import produce from 'immer'
import { combineReducers } from 'redux'
import {
  FeedbackType,
  hideCreateSavedRepliesModal,
  hideFeedbackModal,
  hideOnBoardingV2Modal,
  hideSidebarPreferencesModal,
  showCreateSavedRepliesModal,
  showFeedbackModal,
  showOnBoardingV2Modal,
  showSidebarPreferencesModal,
} from 'shared/store/actions/modal'

import { AnyRootAction, createReducer } from 'typesafe-actions'

interface BasicModal {
  open: boolean
}

export interface FeedbackModal extends BasicModal {
  lastOpenTime?: number
  manual: boolean
  type: FeedbackType
}

interface OnBoardingV2 extends BasicModal {
  fromHelp: boolean
}

const feedbackModal = createReducer<FeedbackModal, AnyRootAction>({
  open: false,
  manual: true,
  type: FeedbackType.SALES,
})
  .handleAction(showFeedbackModal, (state, action) =>
    produce(state, (draft) => {
      draft.open = true
      draft.lastOpenTime = new Date().getTime()
      draft.manual = action?.payload?.manual ?? true
      draft.type = action.payload?.type ?? FeedbackType.SALES
    })
  )
  .handleAction(hideFeedbackModal, (state) => ({
    open: false,
    lastOpenTime: state.lastOpenTime,
    manual: state.manual,
    type: FeedbackType.SALES,
  }))

const sidebarPreferencesModal = createReducer<BasicModal, AnyRootAction>({ open: false })
  .handleAction(showSidebarPreferencesModal, () => ({ open: true }))
  .handleAction(hideSidebarPreferencesModal, () => ({ open: false }))

const createSavedRepliesModal = createReducer<BasicModal, AnyRootAction>({ open: false })
  .handleAction(showCreateSavedRepliesModal, () => ({ open: true }))
  .handleAction(hideCreateSavedRepliesModal, () => ({ open: false }))

const onBoardingV2Modal = createReducer<OnBoardingV2, AnyRootAction>({
  open: false,
  fromHelp: false,
})
  .handleAction(showOnBoardingV2Modal, (state, action) =>
    produce(state, (draft) => {
      const fromHelp = action.payload?.fromHelp
      draft['open'] = true
      draft['fromHelp'] = !!fromHelp
    })
  )
  .handleAction(hideOnBoardingV2Modal, (state) =>
    produce(state, (draft) => {
      draft['open'] = false
    })
  )

export default combineReducers({
  feedbackModal,
  onBoardingV2Modal,
  sidebarPreferencesModal,
  createSavedRepliesModal,
})
